import { SPECIES_GROUPS } from '../../map.constants';

function getChartData(feature) {
  const speciesGroups = feature?.properties?.observationCounts?.species_groups ?? {};

  return Object.entries(SPECIES_GROUPS)
    .map(([key, config]) => ({
      key,
      label: config.label,
      color: config.color,
      fill: config.color,
      icon: config.icon,
      value: speciesGroups[key] ?? 0,
    }))
    .filter(({ value }) => value > 0);
}

export {
  getChartData,
};
